document.addEventListener("DOMContentLoaded", function () {
	jQuery(".inquire-button").on("click", function (e) {
		e.preventDefault();
		var href = jQuery(this).attr("href");
		if (href.startsWith("#")) {
			const popup = jQuery(href);
			if (popup) {
				popup.addClass("active");
			}
		}
	});
	jQuery(".drop-hint-popup__close").on("click", function (e) {
		e.preventDefault();
		var popup = jQuery(this).closest(".drop-hint-popup");
		if (popup) {
			popup.removeClass("active");
		}
	});
});
